import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-invest-info-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ReactiveFormsModule,
    TranslatePipe,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './invest-info-dialog.component.html',
  styleUrl: './invest-info-dialog.component.scss',
})
export class InvestInfoDialogComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (localStorage.getItem('invest_info_dont_show_again') === 'true') {
      this.activeModal.close('success');
    }
  }

  continue() {
    if (this.investForm.controls.dontShowAgain.value) {
      localStorage.setItem('invest_info_dont_show_again', 'true');
    }
    this.activeModal.close('success');
  }

  private fb = inject(FormBuilder);
  protected investForm = this.fb.nonNullable.group({
    dontShowAgain: [false],
  });
}
